import { useTranslation } from 'react-i18next';

export default function ZastitaParkingMesta() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center cursor-pointer">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-parking-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">ParkGuard</span>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">
                Početna
              </a>
              <a href="/blog" className="text-blue-600 font-medium">
                Blog
              </a>
              <a href="/#features" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">
                Karakteristike
              </a>
              <a href="/#faq" className="text-gray-600 hover:text-blue-600 transition-colors font-medium">
                FAQ
              </a>
            </nav>
            <div className="hidden md:flex items-center space-x-4">
              <a
                href="/#checkout-section"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
              >
                Kupi sada
              </a>
            </div>
            <button className="md:hidden w-10 h-10 flex items-center justify-center">
              <i className="ri-menu-line text-xl text-gray-600"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-gray-500 hover:text-blue-600">Početna</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <a href="/blog" className="text-gray-500 hover:text-blue-600">Blog</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900">Zaštita parking mesta</span>
          </nav>
        </div>
      </div>

      {/* Article */}
      <article className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <header className="mb-8">
            <div className="flex items-center space-x-4 mb-4">
              <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                Saveti
              </span>
              <span className="text-gray-500 text-sm">15. januar 2025.</span>
              <span className="text-gray-500 text-sm">5 min čitanja</span>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Kako da zaštitite svoje parking mesto od neovlašćenog korišćenja
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Praktični saveti i rešenja za vlasnice privatnih parking mesta koji žele da spreče neovlašćeno parkiranje.
            </p>
          </header>

          {/* Featured Image */}
          <div className="mb-8">
            <img
              src="https://readdy.ai/api/search-image?query=Private%20parking%20space%20protection%20smart%20barrier%20system%20modern%20urban%20setting%20professional%20photography%20clean%20design&width=800&height=400&seq=parking1&orientation=landscape"
              alt="Zaštićeno parking mesto sa pametnom barijerom"
              className="w-full h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Problem neovlašćenog parkiranja</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Neovlašćeno parkiranje je jedan od najčešćih problema sa kojima se suočavaju vlasnici privatnih parking mesta. 
              Bez obzira da li se radi o stambenim zgradama, poslovnim objektima ili privatnim garažama, ovaj problem može 
              dovesti do frustracije, gubitka vremena i novca.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">Najčešći uzroci problema:</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Nedostatak jasnog označavanja privatnog vlasništva</li>
              <li>Lako dostupna parking mesta bez fizičkih barijera</li>
              <li>Nepostojanje sistema kontrole pristupa</li>
              <li>Nedovoljna vidljivost upozoravajućih znakova</li>
              <li>Blizina javnih sadržaja koji privlače posetioce</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Tradicionalna rešenja i njihovi nedostaci</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">1. Upozoravajuće table</h3>
            <p className="text-gray-700 mb-4">
              Postavljanje tabla sa upozorenjem je najjeftiniji način, ali često nije dovoljno efikasan. 
              Mnogi vozači jednostavno ignorišu table, posebno ako nema fizičkih posledica.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">2. Fiksne barijere</h3>
            <p className="text-gray-700 mb-4">
              Metalni stubovi ili betонske barijere mogu biti efikasni, ali su nepraktični jer zahtevaju 
              fizičko uklanjanje svaki put kada vlasnik želi da koristi mesto.
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">3. Lanac ili konopac</h3>
            <p className="text-gray-700 mb-6">
              Jeftino rešenje koje zahteva izlaženje iz vozila i ručno uklanjanje. Nepraktično u lošem vremenu 
              i može biti lako uklonjeno od strane neovlašćenih lica.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Moderne pametne barijere - optimalno rešenje</h2>
            <p className="text-gray-700 mb-6">
              Pametne parking barijere predstavljaju revoluciju u zaštiti privatnih parking mesta. 
              Kombinuju efikasnost fizičke barijere sa praktičnošću daljinskog upravljanja.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-6">
              <h4 className="font-semibold text-blue-900 mb-3 flex items-center">
                <i className="ri-lightbulb-line mr-2"></i>
                Ključne prednosti pametnih barijera:
              </h4>
              <ul className="space-y-2 text-blue-800">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                  <span>Daljinsko upravljanje do 30 metara udaljenosti</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                  <span>Automatsko zaključavanje u spuštenoj poziciji</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                  <span>Baterija koja traje do 6 meseci</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                  <span>Vodootporna konstrukcija za sve vremenske uslove</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                  <span>Jednostavna instalacija bez potrebe za stručnjacima</span>
                </li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Korak po korak: Instalacija i korišćenje</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Priprema za instalaciju</h3>
            <ol className="list-decimal pl-6 mb-6 space-y-2 text-gray-700">
              <li>Odredite optimalnu poziciju za barijeru (obično na početku parking mesta)</li>
              <li>Proverite da li je površina ravna i stabilna</li>
              <li>Označite mesta za bušenje prema priloženom šablonu</li>
              <li>Pripremite potrebne alate (bušilica, ključevi, metar)</li>
            </ol>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">Proces instalacije</h3>
            <ol className="list-decimal pl-6 mb-6 space-y-2 text-gray-700">
              <li>Izbušite rupe prema označenim mestima</li>
              <li>Pričvrstite metalnu bazu pomoću uključenih ankera</li>
              <li>Postavite glavnu jedinicu na bazu i zategnite vijke</li>
              <li>Testirajte rad barijere i daljinskog upravljača</li>
            </ol>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Dodatni saveti za maksimalnu efikasnost</h2>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 mb-6">
              <h4 className="font-semibold text-yellow-900 mb-3 flex items-center">
                <i className="ri-star-line mr-2"></i>
                Pro saveti:
              </h4>
              <ul className="space-y-3 text-yellow-800">
                <li>
                  <strong>Kombinujte sa tablom:</strong> Postavite jasnu tablu koja upozorava na privatno vlasništvo
                </li>
                <li>
                  <strong>Redovno održavanje:</strong> Proveravajte bateriju i čistite barijeru jednom mesečno
                </li>
                <li>
                  <strong>Rezervni ključ:</strong> Uvek imajte fizički ključ kao rezervu za slučaj kvara daljinskog
                </li>
                <li>
                  <strong>Obavestite komšije:</strong> Informišite susede o novoj barijeri da izbegnete nedorazume
                </li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Ekonomska opravdanost investicije</h2>
            <p className="text-gray-700 mb-4">
              Investicija u pametnu parking barijeru se brzo isplati kada uzmete u obzir:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Ušteda vremena - nema više traženja alternativnog parkinga</li>
              <li>Smanjenje stresa i frustracije</li>
              <li>Povećanje vrednosti nekretnine</li>
              <li>Dugoročna ušteda u odnosu na druge metode zaštite</li>
              <li>Mir i sigurnost da je vaše mesto uvek dostupno</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Zaključak</h2>
            <p className="text-gray-700 mb-6">
              Zaštita privatnog parking mesta više nije luksuz već neophodnost u današnjem urbanom okruženju. 
              Pametne parking barijere predstavljaju optimalno rešenje koje kombinuje efikasnost, praktičnost 
              i pristupačnost. Investicija se brzo isplati kroz uštede vremena, smanjenje stresa i garantovano 
              dostupno parking mesto.
            </p>

            <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3">Spremni da zaštitite svoje parking mesto?</h4>
              <p className="text-gray-700 mb-4">
                Naručite ParkGuard pametnu barijeru već danas i rešite problem neovlašćenog parkiranja zauvek.
              </p>
              <a
                href="/#checkout-section"
                className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                Naručite sada
              </a>
            </div>
          </div>

          {/* Author & Share */}
          <div className="border-t border-gray-200 pt-8 mt-12">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
              <div className="flex items-center mb-4 md:mb-0">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-blue-600 font-bold">PG</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">ParkGuard Tim</h4>
                  <p className="text-gray-600 text-sm">Stručnjaci za parking rešenja</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-gray-600 text-sm">Podelite:</span>
              </div>
            </div>
          </div>

          {/* Related Articles */}
          <div className="mt-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Povezani članci</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <article className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow">
                <img
                  src="https://readdy.ai/api/search-image?query=Smart%20parking%20barrier%20installation%20process%20step%20by%20step%20guide%20tools%20equipment%20modern%20design&width=400&height=200&seq=install2&orientation=landscape"
                  alt="Instalacija parking barijere"
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-medium">
                    Vodič
                  </span>
                  <h4 className="text-xl font-semibold text-gray-900 mt-3 mb-2">
                    Kompletna instalacija parking barijere za početnike
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Detaljno objašnjenje svih koraka instalacije sa slikama i savetima.
                  </p>
                  <a href="/blog/posts/instalacija-barijere" className="text-blue-600 hover:text-blue-700 font-medium text-sm">
                    Pročitaj više →
                  </a>
                </div>
              </article>

              <article className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow">
                <img
                  src="https://readdy.ai/api/search-image?query=Parking%20barrier%20maintenance%20cleaning%20battery%20replacement%20professional%20care%20modern%20equipment&width=400&height=200&seq=maintenance2&orientation=landscape"
                  alt="Održavanje parking barijere"
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <span className="bg-purple-100 text-purple-600 px-3 py-1 rounded-full text-sm font-medium">
                    Održavanje
                  </span>
                  <h4 className="text-xl font-semibold text-gray-900 mt-3 mb-2">
                    Kako da održavate parking barijeru
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Saveti za dugotrajan rad i maksimalnu efikasnost vaše barijere.
                  </p>
                  <a href="/blog/posts/odrzavanje-barijere" className="text-blue-600 hover:text-blue-700 font-medium text-sm">
                    Pročitaj više →
                  </a>
                </div>
              </article>
            </div>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-parking-line text-white text-xl"></i>
                </div>
                <span className="text-xl font-bold">ParkGuard</span>
              </div>
              <p className="text-gray-400 mb-6">
                Pametna rešenja za zaštićeno parkiranje. Vaše parking mesto, vaša kontrola.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Brze veze</h3>
              <ul className="space-y-2">
                <li><a href="/" className="text-gray-400 hover:text-white transition-colors">Početna</a></li>
                <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</a></li>
                <li><a href="/#features" className="text-gray-400 hover:text-white transition-colors">Karakteristike</a></li>
                <li><a href="/#faq" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Podrška</h3>
              <ul className="space-y-2">
                <li><a href="tel:+381612929053" className="text-gray-400 hover:text-white transition-colors">061 29 29 053</a></li>
                <li><a href="mailto:maxiorars@gmail.com" className="text-gray-400 hover:text-white transition-colors">Email podrška</a></li>
                <li><a href="/garancija" className="text-gray-400 hover:text-white transition-colors">Garancija</a></li>
                <li><a href="/povracaj" className="text-gray-400 hover:text-white transition-colors">Povraćaj</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2025 ParkGuard. Sva prava zadržana.</p>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors mt-4 md:mt-0">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
